<template>
  <app-layout>
    <div class="flex flex-col items-center p-4">
      <div class="w-full xl:px-36 sm:px-8">
        <div class="flex flex-row items-center py-4">
          <h1 class="text-lg font-bold inline-flex items-center">
            <sa-icon-button
              iconClass="bx bx-left-arrow-alt"
              @click="handleCreateProductClick"
              with-bg
            />
            <strong>&nbsp;Agregar Producto</strong>
          </h1>
          <div class="ml-auto">
            <sa-button
              type="primary"
              class="items-center px-3 py-3 font-bold rounded"
              @click="updateProduct">
              Guardar
            </sa-button>
          </div>
        </div>
        <div class="flex flex-col space-y-6">
          <product-form :loading=loading :form=form></product-form>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/components/layouts/AppLayout.vue';
import ProductService from '../../../services/ProductService';
import ProductForm from "./Form";
import error from '@/mixins/error';
import _ from "lodash";

export default {
  name: 'ProductUpdate',
  components: {
    AppLayout,
    ProductForm,
  },
  mixins: [
    error,
  ],
  data() {
    return {
      id: undefined,
      loading: false,
      errorMessage: undefined,
      form: {
        name: undefined,
        description: undefined,
        category: undefined,
        brand_model: undefined,
        cost: undefined,
        price: undefined,
        quantity: 0,
        image: undefined,
        minStockAlert: null,
        maxStockAlert: null,
        color: undefined,
        details: undefined,
        location: undefined,
        supplier: null,
        lastPurchasedAt: null,
      }
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.readProduct();
  },
  'errorMessage': {
    deep: true,
    handler: _.debounce(async function () {
      if (this.errorMessage) {
        await this.$toastr.e(this.errorMessage);
        this.errorMessage = undefined;
      }
    }, 300)
  },
  methods: {
    async readProduct() {
      this.loading = true;
      try {
        const product = await ProductService.getById(this.id);
        this.form = {
          name: product.name,
          description: product.description,
          category: {
            id: product.categoryId,
            name: product.category,
          },
          // brand_model: product.brandModel,
          cost: product.cost,
          price: product.price,
          quantity: product.quantity,
          minStockAlert: product.minStockAlert,
          maxStockAlert: product.maxStockAlert,
          color: product.color,
          details: product.details,
          location: product.location,
          supplier: product.supplierId,
          lastPurchasedAt: product.lastPurchasedAt,
        };
      } catch (error) {
        this.errorMessage = this.getErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
    async updateProduct() {
      this.loading = true;
      try {
        await ProductService.update({
          id: this.id,
          product: {
            id: this.id,
            name: this.form.name,
            description: this.form.description,
            category: this.form.category?.id ?? this.form.category,
            brandModel: this.form.brand_model,
            cost: parseFloat(this.form.cost),
            price: parseFloat(this.form.price),
            quantity: parseFloat(this.form.quantity),
            minStockAlert: parseFloat(this.form.minStockAlert) || 0,
            maxStockAlert: parseFloat(this.form.maxStockAlert) || 0,
            color: this.form.color,
            details: this.form.details,
            location: this.form.location,
            supplierId: this.form.supplier,
          },
        });
        this.$toastr.s('Se actualizo con exito');
      } catch (error) {
        this.errorMessage = this.getErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
    handleCreateProductClick() {
      if (this.$store.state.business.id) {
        this.$router.push({ name: 'products.index' });
      } else {
        this.$toastr.i("Tienes que estar en una sucursal para poder crear productos");
      }
    },
  },
}
</script>
